import { render } from "./InvoicingTab.vue?vue&type=template&id=f0bb6b18&scoped=true"
import script from "./InvoicingTab.vue?vue&type=script&lang=js"
export * from "./InvoicingTab.vue?vue&type=script&lang=js"

import "./InvoicingTab.vue?vue&type=style&index=0&id=f0bb6b18&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0bb6b18"]])

export default __exports__